<template>
  <CDropdown
      inNav
      class="c-header-nav-items"
      placement="bottom-end"
      add-menu-classes="pt-0"
  >
    <template #toggler>
      <CHeaderNavLink>
<!--        <div class="c-avatar">-->
<!--          <img-->
<!--              src="../assets/profile.jpg"-->
<!--              class="c-avatar-img "-->
<!--          />-->
<!--        </div>-->
        <avatar :username=username></avatar>
      </CHeaderNavLink>
    </template>

    <CDropdownHeader
        tag="div"
        class="text-center"
        color="light"
    >
      <strong>Settings</strong>
    </CDropdownHeader>
    <CDropdownItem @click="profile()" v-if="isUser">
      <CIcon name="cil-user"/> Profile
    </CDropdownItem>
<!--    <CDropdownItem>-->
<!--      <CIcon name="cil-settings" /> Settings-->
<!--    </CDropdownItem>-->
<!--    <CDropdownItem>-->
<!--      <CIcon name="cil-dollar" /> Payments-->
<!--    </CDropdownItem>-->
    <CDropdownItem @click="exportData()" v-if="isUser">
      <CIcon name="cil-cloud-download" /> Export data
    </CDropdownItem>
<!--    <a id="file" download="report.docx" v-if="isClicked">Download</a>-->
    <CDropdownDivider/>
    <CDropdownItem @click="logout()">
      <CIcon name="cil-lock-locked" /> Logout
    </CDropdownItem>
  </CDropdown>
</template>

<script>
import axios from 'axios'
import Avatar from 'vue-avatar'

export default {
  name: 'TheHeaderDropdownAccnt',
  components: {
    Avatar
  },
  data () {
    return {
      itemsCount: 42,
      isUser: true,
      isClicked: false,
      username: '',
    }
  },
  mounted() {
    const role = localStorage.getItem("roles")
    this.username = localStorage.getItem('name')
    console.log('username', this.username)
    if (role === 'superadmin' || role === 'admin') {
      this.isUser = false
    }
  },
  methods:{
    logout(){
      let self = this;
      let postData = {};
      const token = localStorage.getItem("api_token")

      axios.post(this.$apiAdress + '/api/logout', postData, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
      // axios.post(this.$apiAdress + '/api/logout?token=' + localStorage.getItem("api_token"),{})
      .then(function (response) {
        localStorage.setItem('roles', '');
        localStorage.setItem('company_id', '');
        localStorage.setItem('api_token', '');
        self.$router.push({ path: '/login' });
      }).catch(function (error) {
        console.log(error);
      });
    },
    exportData() {
      let self = this;
      self.isClicked = true
      const token = localStorage.getItem("api_token")
      axios.get(this.$apiAdress + '/api/download/pdf', {
        responseType: 'arraybuffer',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
          'Accept': 'application/pdf'
        }
      }).then(function (response) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'EXODUS_exported_data.pdf'); //or any other extension
        document.body.appendChild(link);
        link.click();
      }).catch(function (error) {
        console.log(error);
      });
    },
    profile() {
      let self = this
      self.$router.push({ path: '/profile' });
    }
  }
}
</script>
<style scoped>
  .c-icon {
    margin-right: 0.3rem;
  }
</style>
